import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import { CURRENT_APPLICATION_APPLICANTS } from "../../../store/application-getters";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import ApplicantSelect from "@Broker/@Modules/util-components/application/applicant-select.vue";
import { Fragment } from "vue-fragment";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import RequestApplicationDetailsTable from "./request-application-details-table.vue";
import { APPLICATION_NOTIFICATION_FREQUENCY } from "@Broker/@Modules/main/store/account/account-getters";
import { differenceBy, isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "RequestApplicationDetails",
  components: {
    ApplicantSelect,
    MaterialInput,
    Fragment,
    RequestApplicationDetailsTable
  },
  mixins: [validationMixin],
  props: {
    applicants: {
      type: Array,
      required: true
    },
    applicationDetails: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedCoApplicants: [],
      columnsClassesForSelectedCoApplicants: {
        applicantFullName: "w-60 w-lg-40",
        property: "w-20 w-lg-30 text-center",
        mortgageDetails: "w-20 w-lg-30 text-center"
      }
    };
  },
  validations: {
    applicationDetails: {
      selectedProperty: {
        required
      },
      selectedMortgageDetails: {
        required
      },
      isMainApplicantSelected: value => value.personalInformationForMainApplicant.length > 0 || value.selectedProperty === 0 || value.selectedMortgageDetails === 0
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("AccountStore", [APPLICATION_NOTIFICATION_FREQUENCY])), mapGetters("ApplicationStore", [CURRENT_APPLICATION_APPLICANTS])), {}, {
    mainApplicant() {
      var _context;
      return _findInstanceProperty(_context = this.applicants).call(_context, applicant => applicant.applicantIndex === 0);
    },
    isValid() {
      return !this.$v.$invalid;
    },
    isMainApplicantValid() {
      return this.$v.applicationDetails.isMainApplicantSelected;
    },
    emailFrequency() {
      return this.APPLICATION_NOTIFICATION_FREQUENCY;
    }
  }),
  watch: {
    isValid: {
      handler(value) {
        this.$emit("valid", value);
      },
      immediate: true
    }
  },
  mounted() {
    this.handleChangeCoApplicants(differenceBy(this.applicants, this.applicationDetails.personalInformationForMainApplicant, "applicantIndex"));
  },
  methods: {
    handleChangeApplicationDetails(value, property = "") {
      const valueToEmmit = isEmpty(property) ? value : _objectSpread(_objectSpread({}, this.applicationDetails), {}, {
        [property]: value
      });
      this.$emit("change-application-details", valueToEmmit);
    },
    handleChangeCoApplicants(selectedCoApplicants) {
      this.selectedCoApplicants = selectedCoApplicants;
      const nonSelectedCoApplicants = differenceBy(this.applicants, selectedCoApplicants, "applicantIndex");
      const personalInformationForMainApplicant = nonSelectedCoApplicants;
      const selectedProperty = nonSelectedCoApplicants.some(applicant => applicant.applicantIndex === this.applicationDetails.selectedProperty) ? 0 : this.applicationDetails.selectedProperty;
      const selectedMortgageDetails = nonSelectedCoApplicants.some(applicant => applicant.applicantIndex === this.applicationDetails.selectedMortgageDetails) ? 0 : this.applicationDetails.selectedProperty;
      this.handleChangeApplicationDetails({
        personalInformationForMainApplicant,
        selectedProperty,
        selectedMortgageDetails
      });
    },
    handleRemoveApplicant({
      applicantIndex
    }) {
      var _context2;
      this.handleChangeCoApplicants(_filterInstanceProperty(_context2 = this.selectedCoApplicants).call(_context2, applicant => applicant.applicantIndex !== applicantIndex));
    }
  }
});